import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "discount-top" };
const _hoisted_2 = { class: "discount-top-left" };
const _hoisted_3 = { class: "discount-logo-wrap" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "discount-title" };
const _hoisted_6 = ["src"];
const _hoisted_7 = {
    key: 0,
    class: "discount-desc"
};
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RetailDiscountCard',
    props: {
        voucher: {},
        merchantName: {}
    },
    emits: ["click"],
    setup(__props) {
        const props = __props;
        const percentageDisplay = computed(() => {
            const pct = props.voucher?.effectiveDiscountPercentage ?? 0;
            return Number.isInteger(pct) ? String(pct) : pct.toFixed(1);
        });
        const merchantSuffix = computed(() => (props.merchantName ? ` at ${props.merchantName}` : ''));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("a", {
                class: "retail-discount-card",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click')))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (_ctx.voucher?.cardUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "discount-logo",
                                    src: _ctx.voucher.cardUrl,
                                    alt: ""
                                }, null, 8, _hoisted_4))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_5, "Save " + _toDisplayString(percentageDisplay.value) + "% with retail cards" + _toDisplayString(merchantSuffix.value), 1)
                    ]),
                    _createElementVNode("img", {
                        class: "discount-arrow",
                        src: require('@/assets/arrow-right.png'),
                        alt: ""
                    }, null, 8, _hoisted_6)
                ]),
                (_ctx.$slots.default)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                        _renderSlot(_ctx.$slots, "default")
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
